
import './modernizr.js'; // 'npm run modernizr' to create this file



// WEBPACK FOOTER //
// ./src/vendor.ts